import { Link, useLocation } from 'react-router-dom';
import { useApp } from '../AppContext';
import { api } from '../api';

export default function Nav({ onLogout }) {
  const { user, site, theme, toggleTheme } = useApp();
  const loc = useLocation();
  const at = (path) => loc.pathname === path;

  if (!user) return null;

  const features = site?.features || {};
  const perms = user?.permissions || {};

  const link = (to, label, external = false) => {
    const active = !external && at(to);
    const style = {
      display: 'inline-flex', alignItems: 'center',
      padding: '5px 10px', textDecoration: 'none', fontSize: 13, fontWeight: 500,
      borderRadius: 'var(--radius)', fontFamily: 'var(--font)',
      color: active ? 'var(--accent)' : 'var(--fg2)',
      background: active ? 'var(--accent-dim)' : 'transparent',
      transition: 'all 0.12s ease',
    };
    if (external) return <a key={to} href={api.flaskUrl(to)} style={style}
      onMouseEnter={e => { e.currentTarget.style.color = 'var(--accent)'; e.currentTarget.style.background = 'var(--accent-dim)'; }}
      onMouseLeave={e => { e.currentTarget.style.color = 'var(--fg2)'; e.currentTarget.style.background = 'transparent'; }}
    >{label}</a>;
    return <Link key={to} to={to} style={style}
      onMouseEnter={e => { if (!active) { e.currentTarget.style.color = 'var(--accent)'; e.currentTarget.style.background = 'var(--accent-dim)'; } }}
      onMouseLeave={e => { if (!active) { e.currentTarget.style.color = 'var(--fg2)'; e.currentTarget.style.background = 'transparent'; } }}
    >{label}</Link>;
  };

  return (
    <nav style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0 20px', height: 52,
      background: 'var(--nav-bg)',
      borderBottom: '1px solid var(--border)',
      boxShadow: 'var(--shadow)',
      position: 'sticky', top: 0, zIndex: 100,
      gap: 12,
    }}>
      <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', flexShrink: 0 }}>
        <div style={{ width: 28, height: 28, background: 'var(--accent)', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ color: '#fff', fontSize: 11, fontWeight: 700, letterSpacing: '-0.03em', fontFamily: 'var(--font)' }}>SD</span>
        </div>
        <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--fg)', letterSpacing: '-0.02em', fontFamily: 'var(--font)' }}>{site?.name || 'SwimDesk'}</span>
        <span style={{ fontSize: 10, background: 'var(--accent-dim)', color: 'var(--accent)', padding: '1px 6px', borderRadius: 10, fontWeight: 600, fontFamily: 'var(--font)' }}>React</span>
      </Link>

      <div style={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap', flex: 1, justifyContent: 'center' }}>
        {link('/', 'Home')}
        {features.signins    && link('/signins', 'Sign-Ins')}
        {features.signin_log && perms.can_view_signin_log && link('/signin-log', 'Log')}
        {features.parties    && link('/party', 'Parties')}
        {features.reports    && perms.can_view_reports   && link('/manager-report', 'Reports')}
        {features.members    && perms.can_manage_members && link('/members', 'Members')}
        {features.guest_id   && perms.can_manage_members && link('/guests', 'Guests')}
        {features.codes      && perms.can_manage_codes   && link('/code-generator', 'Cards', true)}
        {perms.can_import_members  && link('/membership-import', 'Import')}
        {perms.can_access_admin    && link('/admin', 'Admin')}
        {perms.can_access_settings && link('/settings', 'Settings')}
        {link('/instructions', 'Help')}
      </div>

      <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
        <button onClick={toggleTheme} style={{
          width: 32, height: 32, borderRadius: 'var(--radius)', border: '1px solid var(--border)',
          background: 'var(--bg3)', cursor: 'pointer', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'var(--fg2)',
        }} title={theme === 'dark' ? 'Light mode' : 'Dark mode'}>
          {theme === 'dark' ? '☀️' : '🌙'}
        </button>

        <Link to="/account" style={{ display: 'flex', alignItems: 'center', gap: 7, padding: '4px 10px', borderRadius: 'var(--radius)', background: 'var(--bg3)', border: '1px solid var(--border)', textDecoration: 'none' }}>
          <div style={{ width: 22, height: 22, borderRadius: '50%', background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ color: '#fff', fontSize: 10, fontWeight: 700, fontFamily: 'var(--font)' }}>{(user.username || '?')[0].toUpperCase()}</span>
          </div>
          <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--fg2)', fontFamily: 'var(--font)' }}>{user.username}</span>
        </Link>

        <button onClick={onLogout} style={{
          padding: '5px 12px', borderRadius: 'var(--radius)', border: '1px solid var(--border)',
          background: 'transparent', cursor: 'pointer', fontSize: 12, fontWeight: 500,
          color: 'var(--fg3)', fontFamily: 'var(--font)',
        }}
          onMouseEnter={e => { e.currentTarget.style.color = 'var(--danger)'; e.currentTarget.style.borderColor = 'var(--danger)'; }}
          onMouseLeave={e => { e.currentTarget.style.color = 'var(--fg3)'; e.currentTarget.style.borderColor = 'var(--border)'; }}
        >Logout</button>
      </div>
    </nav>
  );
}
